import styled from "styled-components";

import colors from "../../../assets/css/colors";
import examplePix from "../../../assets/img/example-pix.svg"


import { RadioButtonInterface } from "./interfaces";

export const Container = styled.div`
    display: flex;

    @media (max-width: 500px){
        display: block;
    }
`;

export const FirstColumn = styled.div`
    width: 380px;
    margin-right: 71px;

    @media (max-width: 500px){
        width: 100%;
    }
`;

export const Title = styled.h2`
    font: normal normal normal 14px Circular Std Book;
    color: #454546;
    margin-bottom: 9px;
`;

export const SubText = styled.p`
    font: normal normal normal 14px Circular Std Book;
    color: #B8B4CC;
    margin-bottom: 22px;
`;

export const RadioButtonRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    margin-bottom: 28px;
`;

export const RadioButtonForm = styled.div`
    display: flex;
    align-items: center;
`;

export const RadioButtonContainer = styled.div`
    display: flex;
    width: 10px;
    height: 10px;
    justify-content: center;
    align-items: center;
    border: 1px solid ${colors.primary};
    border-radius: 9px;
    margin-right: 8px;
`;

export const RadioButtonContent = styled.div`
    width: 6px;
    height: 6px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${(p: RadioButtonInterface) => p.isPrimary ? colors.primary : "transparent"};
`;

export const RadioButtonDescription = styled.span`
    font: normal normal 300 13px Muli;
    color: #707070;
`;

export const SecondColumn = styled.div`
    width: 270px;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 35px;
    }
`;

export const PixKeyContainer = styled.div`
    border-bottom: 1px solid #B8B4CC;
    margin-bottom: 10px;
`;

export const TitleAndTrashContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const ButtonContainer = styled.div`
    width: 380px;

    @media (max-width: 500px){
        width: 100%;
        margin-bottom: 35px;
    }
`;